import { IGetAtributosCompraUseCase } from "../../../presentation/useCases/read/get_atributos_compra_use_case";
import { telaIdsToNumber, TelasIds } from "../../../utils/tela_ids";
import { AtributoCompra } from "../../models/atributo_compra";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetAtributosCompraUseCase
 */

export class GetAtributosCompraUseCase implements IGetAtributosCompraUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getAtributosCompra(
    telaId: TelasIds | null,
  ): Promise<AtributoCompra | null> {
    return await this.repository.getAtributosCompra(
      telaId !== null ? telaIdsToNumber(telaId) : null,
    );
  }
}
